import React, { useEffect } from 'react'

import {
    HomeOutlined,
    MoneyCollectOutlined,
    StockOutlined} from '@ant-design/icons';

import { Empty, Table } from 'antd';
import { useApi } from '../../Utils';
import Column from 'antd/lib/table/Column';


// @ts-ignore
import { useSelector } from 'react-redux';

interface OrderRow {
    id: number
    userId: string
    sku: string
    stock: number
    user: {
        id: number
        name: string
        email: string
    }
    // sku: string
    // glosa?: string
    // stockTotal: number
    // fechaActualizacion: Date
    // stockManager?: number
    // stockTransit?: number
}

export default function SyncStockHistoriales({ isMobile, exposeSubMenu, setMainLoading }: any) {
    const { data, loading } = useApi<any>('get', 'v3/sync/stockHistoriales')
    const [records, setRecords] = React.useState<OrderRow[]>([])
    const { permissions } = useSelector((state: any) => state)


    useEffect(() => {
        if (data?.status === 'success') {
            setRecords(data.historiales)
            // setRecords(data.orders)
            // console.log(data.orders)
        }
    }, [data])

    useEffect(() => {
        if (!!exposeSubMenu) {
            const _submenu = [
                { key: 'index', name: 'Papel de Trabajo', icon: <HomeOutlined /> },
            ]

            if (permissions.includes('FacturacionMensual')) {
                _submenu.push({ key: 'emission', name: 'Facturación mensual', icon: <MoneyCollectOutlined /> },)
            }

            if (permissions.includes('WebStock')) {
                _submenu.push({ key: 'sync-stock', name: 'Stock en Web', icon: <StockOutlined /> },)
                _submenu.push({ key: 'historiales-stock', name: 'Historiales', icon: <StockOutlined /> },)
            }

            exposeSubMenu(_submenu)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exposeSubMenu])

    useEffect(() => {
        setMainLoading(false)
    }, [setMainLoading])

    
    return (
        <div className="App">
            <div className="Orders">
                <div className="Wrapper">
                    <Table
                        dataSource={records}
                        loading={loading}
                        pagination={false}
                        rowKey={(record) => `Row${record.id}`}
                        className='TableListAll'
                        size='small'
                        locale={{
                            emptyText: (
                                <Empty
                                    style={{ marginTop: '32px', marginBottom: '48px' }}
                                    description='No se han encontrado productos con los criterios de bùsqueda.'
                                >
                                </Empty>
                            )
                        }}
                        footer={() => <>Total de productos {records.length}</>}
                    >
                        <Column
                            title='Id'
                            dataIndex='id'
                            key='id'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.id.localeCompare(b.id)}
                        />
                        <Column
                            title='Usuario'
                            dataIndex='userId'
                            key='userId'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.glosa?.localeCompare(b.glosa)}
                            render={(value, record: OrderRow) => record.user.name}
                        />
                        <Column
                            title='SKU'
                            dataIndex='sku'
                            key='sku'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.sku.localeCompare(b.sku)}
                        />
                        <Column
                            title='Stock modificado'
                            key='stock'
                            dataIndex='stock'
                            render={(value, record: OrderRow) => record.stock}
                        />
                        <Column
                            title='Fecha modificación'
                            key='created_at'
                            dataIndex='created_at'
                        />
                    </Table>
                </div>
            </div>
        </div>
    )
}
